module.exports = __webpack_public_path__ + "media/images/common/check_delete_btn_l_ov-3def5f5c335a76cab407ef3e08d4c036.png";